import { render, staticRenderFns } from "./DashboardWidthWrapper.vue?vue&type=template&id=4e25771e&scoped=true&"
import script from "./DashboardWidthWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardWidthWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidthWrapper.vue?vue&type=style&index=0&id=4e25771e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25771e",
  null
  
)

export default component.exports